import React from "react";
import AddandEditProfileContainer from "../../containers/AddandEditProfileContainer/AddandEditProfileContainer";

export default function AddandEditProfilePage() {
  return (
    <>
      <div><AddandEditProfileContainer></AddandEditProfileContainer></div>
    </>
  );
}
